// import { List } from "immutable";
import _ from "lodash";
import * as React from "react";
import * as BS from "react-bootstrap";
import * as Comp from "../../../../components";
import { ComponentWithValidatedForm } from "../../../../components/validation";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";
// import { Utility } from "../../../../utils";

interface OwnProps {
    api: Api;
    onSubmit: (model: Forms.Abstract.GradeData, body: any) => void;
}

interface OwnState {
    categories: M.Abstract.GradingCategory[];
    maxGrade?: number;
    minGrade?: number;
    placements: M.Abstract.GradingPlacement[];
    showForm: boolean;
}

export class GradingForm extends ComponentWithValidatedForm<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        const formModel = new Forms.Abstract.Grade();
        this.state = {
            ...this.getInitialState(formModel),
            categories: [],
            placements: [],
            showForm: false,
        };
    }

    public resetFormData(callback?: () => void) {
        this.setState({
            ...this.state,
            showForm: false,
            formModel: new Forms.Abstract.Grade(),
        }, callback);
    }

    public setFormData(abstract: M.Abstract.AbstractForGrader, type: M.Abstract.AbstractType) {
        let maxGrade = 0;
        let minGrade = 99;
        const categories = type.gradingCategories || [];
        const placements = type.gradingPlacements || [];

        const formModel = this.getFormModelData<Forms.Abstract.GradeData>();
        formModel.comment = abstract.grade ? (abstract.grade.comment || "") : "";
        formModel.placementId = abstract.grade ? abstract.grade.placementId : null;
        formModel.placementIsRequired = placements.length > 0;

        if (type.graderCommentValidationText)
            formModel.commentRequiredText = type.graderCommentValidationText;

        formModel.categories = (type.gradingCategories || [])
            .map((c) => {
                const category = abstract.grade
                    ? _.find(abstract.grade.categories, (_c) => _c.categoryId === c.id)
                    : undefined;

                const placement = _.find(placements, (x) => x.id === formModel.placementId);

                return {
                    categoryId: c.id,
                    grade: category ? category.grade : null,
                    name: c.name,
                    placementIsAbstain: !!placement && placement.isAbstain,
                };
            });

        for (const c of categories) {
            const max = _.max(c.scale.map((s) => s.value));
            const min = _.min(c.scale.map((s) => s.value));
            if (max && max > maxGrade)
                maxGrade = max;
            if (min && min < minGrade)
                minGrade = min;
        }

        this.updateFormModelData(formModel, () => {
            this.setState({
                ...this.state,
                categories,
                maxGrade,
                minGrade,
                placements,
                showForm: true,
            });
        });
    }

    public render() {
        if (!this.state.showForm)
            return null;

        const modelData = this.getFormModelData<Forms.Abstract.GradeData>();

        const placementOpts: M.Editors.SelectItem[] = this.state.placements.map((item) => ({
            id: item.id,
            render: item.name,
        }));

        const placementField = this.state.placements.length
            ? <Comp.Editors.RadioOrCheckListField
                formComponent={this}
                name="placementId"
                compact
                items={placementOpts}
                type="radio"
            />
            : null;

        const legend = this.state.categories.length > 1
            ? <p><strong>Grade ({this.state.minGrade} = worst, {this.state.maxGrade} = best)</strong></p>
            : null;

        let categories = null;
        if (this.state.categories.length > 1) {
            categories = this.state.categories.map((c, i) => {
                const category = _.find(modelData.categories, (_c) => _c.categoryId === c.id);
                const grade = category ? category.grade : null;
                const catErrors = this.getFieldErrors(`categories[${i}]`);
                return <Comp.Editors.FormField key={i} compact name="" label={`${c.name}:`}>
                    <BS.ButtonGroup className="btn-group-justified">
                        {c.scale.map((s, j) => (
                            <BS.Button bsStyle={grade === s.value ? "primary" : "default"} key={j} onClick={() => this.handleGradeChange(c.id, s.value)}>
                                {s.value}
                            </BS.Button>
                        ))}
                    </BS.ButtonGroup>
                    <Comp.Editors.FormFieldErrors errors={catErrors} />
                </Comp.Editors.FormField>;
            });
        }
        else if (this.state.categories.length === 1) {

            const items: M.Editors.SelectItem[] = this.state.categories[0].scale.map((s) => ({
                id: s.value,
                render: `${s.value}: ${s.label}`,
            }));

            categories = <Comp.Editors.RadioOrCheckListField
                formComponent={this}
                name="categories[0].grade"
                compact
                items={items}
                label="Grade:"
                required={false}
                type="radio"
            />;
        }

        return <Comp.Validation.ValidatedForm
            formComponent={this}
            model={this.state.formModel.data}
            onValidSubmit={async (model) => this.handleSubmit(model)}
            onInputChange={(inputName, value) => this.onInputChangeHandler(inputName)}
            schema={this.state.formModel.rules}
            scrollToErrors={false}
            showErrorsOnSubmit={false}
            ref={(ref: any) => this.form = ref}
        >
            {placementField}
            {legend}
            {categories}
            <Comp.Editors.TextAreaField formComponent={this} name="comment" compact />
            <Comp.Editors.SubmitField compact label="Save and continue" showProcessing={this.state.formProcessing} />
        </Comp.Validation.ValidatedForm>;
    }

    private handleGradeChange(categoryId: number, grade: number) {
        const formModel = this.getFormModelData<Forms.Abstract.GradeData>();
        const category = _.find(formModel.categories, (c) => c.categoryId === categoryId);
        if (category) {
            category.grade = category.grade === grade ? null : grade;
            this.updateFormModelData(formModel);
        }
    }

    private handlePlacementChange() {
        const formModel = this.getFormModelData<Forms.Abstract.GradeData>();

        if (formModel.placementId) {
            const p = _.find(this.state.placements, (x) => x.id === formModel.placementId);
            formModel.placementIsReject = p ? p.isReject : false;
            for (const c of formModel.categories)
                c.placementIsAbstain =  !!p && p.isAbstain;
        }
        else {
            formModel.placementIsReject = false;
            for (const c of formModel.categories)
                c.placementIsAbstain =  false;
        }

        this.updateFormModelData(formModel);
    }

    private handleSubmit(model: Forms.Abstract.GradeData) {
        const body = {
            comment: model.comment || null,
            grades: model.categories.map((c) => ({
                categoryId: c.categoryId,
                grade: c.grade,
            })),
            placementId: model.placementId,
        };

        this.props.onSubmit(model, body);
    }

    private onInputChangeHandler(inputName: string) {
        if (inputName === "placementId")
            this.handlePlacementChange();
    }
}



// WEBPACK FOOTER //
// ./src/containers/user/abstractGrading/components/GradingForm.tsx